import React from 'react';
import Select from 'react-select';
import FlagIcon from './FlagIcon';

export default class CountrySelect extends React.Component {
    renderOption (option) {
        return (
            <span><FlagIcon style={{float: 'left', marginRight: '7px', marginTop: '4px'}} iso={option.iso} /> {option.label}</span>
        );
    }
    renderValue (option) {
        return (
            <span>
                <FlagIcon style={{float: 'left', marginRight: '7px', marginTop: '4px'}} iso={option.iso} /> {option.label}
            </span>
        );
    }
    render () {
        var ops = [
            { label: 'New Zealand', value: 'New Zealand', iso: 'nz' },
            { label: 'Australia', value: 'Australia', iso: 'au' },
            { label: 'United Kingdom', value: 'United Kingdom', iso: 'gb' },
            { label: 'United States', value: 'United States', iso: 'us' },
            { label: 'Canada', value: 'Canada', iso: 'ca' },
            { label: 'India', value: 'India', iso: 'in' },
            { label: 'Indonesia', value: 'Indonesia', iso: 'id' },
            { label: 'South Africa', value: 'South Africa', iso: 'za' },
            { label: 'Ireland', value: 'Ireland', iso: 'ie' },
        ];
        return (
            <Select
                placeholder="Country"
                options={ops}
                value={this.props.country}
                optionRenderer={this.renderOption}
                valueRenderer={this.renderValue}
                onChange={this.props.onChange} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/CountrySelect.js